import { Avatar, HStack, Text } from "@chakra-ui/react";

export default function Profile({ name, size = 'xs', ...props }){
    return(
    <HStack>
        <Avatar name={name} size={size} {...props} />
        <Text textTransform="capitalize" children={name} fontSize="sm" />
    </HStack>
    )
}